import '@babel/polyfill';

import Vue from 'vue';
import { createApp } from './index';
import { trimHttp } from 'g-public/utils';
import { ReportDirective } from 'g-public/report'

function preload(banners) {
    for (let i = 0; i < banners.length; i++) {
        const $link = document.createElement('link');
        $link.rel = 'preload';
        $link.as = 'image';
        $link.href = trimHttp(banners[i].img);

        document.head.insertBefore($link, null);
    }
}
Vue.use(ReportDirective)

// 执行初始化
// window.iris && window.iris({
//     app_key: 'web_ogv',
//     group: 'cheese',
//     autoPref: true,
//     exclude: [
//     ],
//     sample: {
//         net: 0.1,
//         custom: 1
//     },
//     rateLimit: 500,
//     env: process.env.NODE_ENV
// });

Vue.mixin({
    beforeRouteUpdate(to, from, next) {
        const {asyncData} = this.$options;
        if (asyncData) {
            asyncData({
                store: this.$store,
                route: to
            }).then(next).catch(next);
        } else {
            next();
        }
    }
});

const { app, router, store } = createApp({
    // route,
    // app: APP,
    // store: _store,
    // sentry: {
    //     dsn: `${process.env.NODE_ENV === 'production' ? 'https' : 'http'}://a8a097f7316346fc829bb7d4d3b310fc@api.bilibili.com/x/traceback/86`
    // }
});

// console.log(window.__INITIAL_STATE__);

if (window.__INITIAL_STATE__) {
    store.replaceState(window.__INITIAL_STATE__);

    preload(window.__INITIAL_STATE__.banners);
} else {
    const matchedComponents = router.getMatchedComponents();
    Promise.all(matchedComponents.map(component => {
        return component.asyncData && component.asyncData({
            store,
            route: router.currentRoute,
            context: {
                ua: window ? window.navigator.userAgent : ''
            }
        });
    })).then(() => {
        preload(app.$store.state.banners);

        app.$mount('#client-app');
    }).catch();
}

router.onReady(() => {
    router.beforeResolve((to, from, next) => {
        const matched = router.getMatchedComponents(to);
        const preMatched = router.getMatchedComponents(from);
        let diffed = false;
        const activated = matched.filter((c, i) => {
            return diffed || (diffed = (preMatched[i] !== c));
        });

        if (!activated.length) {
            next();
        } else {
            Promise.all(activated.map(c => {
                if (c.asyncData) {
                    return c.asyncData({
                        store,
                        route: to,
                        context: {
                            ua: window ? window.navigator.userAgent : ''
                        }
                    });
                }
            })).then(() => {
                next();
            }).catch(next);
        }
    });
    if (window && window.document.getElementById('app')) {
        app.$mount('#app');
    }
});
